export default () => {
  const script = document.createElement('script');

  script.async = true;
  script.setAttribute('data-cmp-ab', '2');
  script.src = 'https://emrldco.com/NTg2NDE0.js?t=586414';

  document.head.appendChild(script);
};
